import store from 'dashboard/store';
import PatientRecord from 'dashboard/templates/views/Patient/PatientRecord';

import overview from './overview';
import medication from './medication';
import progress from './progress';
import physicalActivity from './physical-activity';
import healthyNutrition from './healthy-nutrition';
import smokingCessation from './SC';
import stressRelief from './stress-relief/index';
import knowledge from './knowledge';

/**
 * Patient record routes
 * @name router.Patient-record
 */

export default {
    path: 'record',
    component: PatientRecord,
    meta: {
        title: 'patient.patientRecord',
        loggedInOnly: true,
        inSDMSessionOnly: true
    },
    children: [
        overview,
        medication,
        progress,
        physicalActivity,
        healthyNutrition,
        smokingCessation,
        stressRelief,
        knowledge,
    ],
    async beforeEnter(to, from, next) {
        const currentPatientId = from.params?.patientId;
        const newPatientId = to.params?.patientId;

        if (!newPatientId) {
            // if there's no patientId in the url, redirect to the welcome screen
            next({name: 'Alerts'});
            return;
        }

        // Update user if back is used as everything stays cached in computed
        if ((currentPatientId === undefined && newPatientId) ||
            currentPatientId !== undefined && currentPatientId !== newPatientId
        ) {
            await Promise.all([
                store.dispatch('patientSummary/get', newPatientId, {root: true}),
            ]);
        }

        // if there's a followup session then proceed to the patient record
        if (store.getters['followupSession/type']) {
            next();
        } else {
            // otherwise try to restore the session from local storage
            await store.dispatch('followupSession/restore', newPatientId);
            if (store.state.followupSession.patientId === newPatientId) {
                // if the session is successfully restored, then proceed to the record
                next();
            } else {
                // otherwise, just go to the patient overview
                next({name: 'PatientOverview', params: {patientId: newPatientId}});
            }
        }
    }
};
